import React from 'react';
import { Paper,Card, CardContent, Typography, Avatar, Box, useTheme, useMediaQuery } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

function MetricCard({ data, title, icon }) {
    const theme = useTheme();
    const isLg = useMediaQuery(theme.breakpoints.up('lg')); // true when screen >= lg

    return (
        <Paper 
            elevation={3}
            sx={{
                borderRadius: 3,
                boxShadow: '0 2px 14px rgba(0,0,0,0.10)',
                background: 'linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
            }}
        >
            <CardContent sx={{ padding: isLg ? 4 : 3 }}> 
                <Box
                    display="flex"
                    flexDirection={isLg ? 'row' : 'column'}
                    alignItems={isLg ? 'center' : 'flex-start'}
                    justifyContent="space-between"
                    gap={isLg ? 6 : 4} 
                >
                    
                        <Box sx={{width:80}}>
                            <Typography
                                variant="subtitle"
                                color="primary.dark"
                                sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8, mb: 0.5 }}
                            >
                                {title}
                            </Typography>
                        </Box>


                    {/* --- Right side: Chart --- */}
                    <Box sx={{ flexGrow: 0, width: '100%', height: isLg ? 140 : 200, minWidth: 70}}> 
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart
                                data={data?.dailyCount?.map(item => ({
                                    date: new Date(item.day_start).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
                                    count: item.count
                                }))}
                                margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
                            >
                                <XAxis
                                    dataKey="date"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#555', fontSize: 12 }}
                                />
                                <YAxis
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#555', fontSize: 12 }}
                                    width={30}
                                />
                                <CartesianGrid stroke="#eee" strokeDasharray="3 3" vertical={false} />
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: '#fff',
                                        borderRadius: 10,
                                        border: 'none',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        fontSize: 12,
                                        padding: '8px 12px',
                                    }}
                                    cursor={{ stroke: '#1976d2', strokeWidth: 2, strokeDasharray: '5 5' }}
                                />
                                <Line
                                    type="natural"
                                    dataKey="count"
                                    stroke="#1976d2"
                                    strokeWidth={3}
                                    dot={{ r: 4, stroke: '#1976d2', strokeWidth: 2, fill: '#fff' }}
                                    activeDot={{ r: 6, stroke: '#1976d2', strokeWidth: 2, fill: '#1976d2' }}
                                    animationDuration={1000}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </Box>
                </Box>
            </CardContent>

        </Paper>
    );
}

export default MetricCard;
